// @flow
import React, { Component, createRef } from 'react'
import type { Node } from 'react'
import _ from 'lodash'

type Props = {|
  children: Node,
  widget: Node
|}

type State = {|
  position: 'absolute' | 'fixed',
  top: number
|}

const LEFT_WIDGET_OFFSET = 620
const FIXED_TOP_WIDGET_OFFSET = 70

export default class FloatingWidget extends Component<Props, State> {
  quakedFn: Function

  wrapperRef: Object = createRef()
  widgetRef: Object = createRef()
  state = {
    position: 'absolute',
    top: 0
  }

  constructor(props: Props) {
    super(props)

    this.quakedFn = () => this.quaked()
  }

  componentDidMount() {
    window.addEventListener('scroll', this.quakedFn)
    window.addEventListener('resize', this.quakedFn)
    this.quaked()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.quakedFn)
    window.removeEventListener('resize', this.quakedFn)
  }

  quaked() {
    const wrapper = this.wrapperRef.current
    const widgetElement = this.widgetRef.current

    if (_.isNull(this.props.widget)) return

    const topBoundary = wrapper.offsetTop
    const bottomBoundary = wrapper.offsetTop + wrapper.offsetHeight
    const widgetHeight = widgetElement.offsetHeight

    let top = null
    let position = ''

    if (window.scrollY + FIXED_TOP_WIDGET_OFFSET <= topBoundary) {
      // when scroll upper then wrapper
      position = 'absolute'
      top = topBoundary
    } else if (window.scrollY + FIXED_TOP_WIDGET_OFFSET <= bottomBoundary - widgetHeight) {
      // when scroll in wrapper
      position = 'fixed'
      top = FIXED_TOP_WIDGET_OFFSET
    } else {
      // when scroll lower then wrapper
      position = 'absolute'
      top = bottomBoundary
    }

    this.setState({ top, position })
  }

  render() {
    const { children, widget } = this.props
    const { position, top } = this.state

    return (
      <div ref={this.wrapperRef}>
        {children}
        <div ref={this.widgetRef} style={{ position, top }}>
          <div style={{ position: 'absolute', left: LEFT_WIDGET_OFFSET }}>{widget}</div>
        </div>
      </div>
    )
  }
}
